onComplete(() => {
	// Fixed Scroll Navigatie
	const isMobile = window.matchMedia("(max-width: 768px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 150 : 150;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})

	// Bigmenu
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	dropdownToggles.forEach(toggle => {
		toggle.addEventListener('click', () => {
			const parentLi = toggle.closest('li.dropdown');

			if (parentLi) {
				const bigMenu = parentLi.querySelector('.dropdown-bigmenu');

				if (bigMenu) {
					bigMenu.classList.toggle('show');
					document.querySelectorAll('.dropdown-bigmenu.show').forEach(otherBigMenu => {
						if (otherBigMenu !== bigMenu) {
							otherBigMenu.classList.remove('show');
						}
					});
				}
			}
		});
	});

	document.addEventListener('click', (event) => {
		if (!event.target.closest('.dropdown')) {
			document.querySelectorAll('.dropdown-bigmenu.show').forEach(bigMenu => {
				bigMenu.classList.remove('show');
			});
		}
	});

	// Productenmenu
	const producten_button = document.querySelector('.btn-producten');
	const producten_list = document.querySelector('.productenlist');

	producten_button.addEventListener('click', () => {
		producten_list.classList.toggle('show');
	});

	{
		// Popup
		const POPUP_IDENTIFIER = 'nieuwsbrief'
		// Triggers
		const POPUP_SCROLL_TRIGGER = 0.40 // 40%
		const POPUP_DELAY_MS = 30_000 // 30s
		// Suppression rule
		const POPUP_DISMISS_WAIT_DAYS = 14
		// Cookies
		const COOKIE_DISMISSED = POPUP_IDENTIFIER + '-dismissed'
		// Helpers
		const isLoggedIn = (
			document.documentElement.hasAttribute('data-logged')
			&& document.documentElement.getAttribute('data-logged') !== 'false'
		)

		const setupPopup = () => {
			if (
				isLoggedIn
				|| window.util?.cookies.get(COOKIE_DISMISSED)
			) {
				return
			}
			const popupElement = document.getElementById(POPUP_IDENTIFIER)
			if (!popupElement) {
				return
			}
			const presetList = popupElement.querySelector(
				'[data-partial="preset-list"]:not([data-preset-count="0"])'
			)
			if (!presetList) {
				return
			}

			let shown = false
			let delayTimer = null
			const cleanup = () => {
				window.removeEventListener('scroll', onScroll, {
					passive: true
				})
				document.removeEventListener('mouseout', onExitIntent)
				if (delayTimer) {
					window.clearTimeout(delayTimer)
				}
				delayTimer = null
			}

			const showPopup = () => {
				if (shown) {
					return
				}
				shown = true
				cleanup()

				const storeDismiss = () => {
					window.util?.cookies.set(
						COOKIE_DISMISSED,
						(new Date()).toISOString(),
						POPUP_DISMISS_WAIT_DAYS,
					)
				}

				window.modalShow?.show?.('#' + POPUP_IDENTIFIER, {
					onClose: storeDismiss,
					onClosing: storeDismiss,
				})
			}

			const onScroll = () => {
				const documentElement = document.documentElement
				const scrollTop = window.pageYOffset || documentElement.scrollTop || 0
				const scrollHeight = documentElement.scrollHeight || 0
				const clientHeight = documentElement.clientHeight || 0

				const scrollable = Math.max(scrollHeight - clientHeight, 1)
				const progress = scrollTop / scrollable

				if (progress >= POPUP_SCROLL_TRIGGER) {
					showPopup()
				}
			}

			const onExitIntent = (event) => {
				// Exit intent: muis verlaat viewport bovenaan (desktop)
				if (event.clientY <= 0) {
					showPopup()
				}
			}

			// 30s delay
			delayTimer = window.setTimeout(showPopup, POPUP_DELAY_MS)
			// 40% scroll
			window.addEventListener('scroll', onScroll, {
				passive: true,
			})
			// Exit intent
			document.addEventListener('mouseout', onExitIntent)
		}
		setupPopup()
	}
});